export default __webpack_public_path__ + "static/bortprovodnik-73f8731371b442056ea6e8de8586fdfe.jpg";